import AnimationConstant from '@/constants/AnimationConstant'
const { MAX_FRAME_COUNT } = AnimationConstant

const mixin = {
  data: function () {
    return {
      autoscrollSpeed: 0,
      autoscrollTimeout: null
    }
  },
  methods: {
    setAutoscrollCanvasDimensions () {
      const { padding, width, keyframeWidths } = this.canvasDimensions
      const leftX = width * 0.05
      const rightX = width - leftX
      const inversePercentage = 1 / leftX
      const scrollSpeed = inversePercentage * keyframeWidths.full * 0.03
      this.canvasDimensions.autoscroll = {
        leftX,
        rightX,
        scrollSpeed,
        maxPanX: -MAX_FRAME_COUNT * keyframeWidths.full - padding + width
      }
    },
    setAutoscroll (x) {
      const { width, autoscroll } = this.canvasDimensions
      const { leftX, rightX, scrollSpeed } = autoscroll
      const autoscrollTimeout = this.autoscrollTimeout
      const speed = this.autoscrollSpeed
      if (x >= 0 && x <= leftX) {
        if (!autoscrollTimeout || speed >= 0 || (autoscrollTimeout && speed < 0)) {
          this.clearAutoscroll()
          this.autoscrollSpeed = (x - leftX) * scrollSpeed
          this.autoscrollTimeout = setTimeout(this.autoscrollCanvas, 400)
        }
      } else if (x >= rightX && x <= width) {
        if (!autoscrollTimeout || speed <= 0 || (autoscrollTimeout && speed > 0)) {
          this.clearAutoscroll()
          this.autoscrollSpeed = (x - rightX) * scrollSpeed
          this.autoscrollTimeout = setTimeout(this.autoscrollCanvas, 400)
        }
      } else {
        this.clearAutoscroll()
      }
    },
    autoscrollCanvas () {
      if (this.autoscrollSpeed === 0) { return }

      window.requestAnimationFrame(() => {
        const vpt = this.canvas.viewportTransform
        let pannedX = vpt[4] -= this.autoscrollSpeed
        const { width, autoscroll } = this.canvasDimensions
        pannedX = Math.max(Math.min(0, pannedX), autoscroll.maxPanX)
        vpt[4] = pannedX

        const x = this.autoscrollSpeed < 0 ? 0 : width

        this.updateFrameDots()
        this.updateFrameRange()
        this.updateCursorFrame(x)
        this.updateFrameTimeTexts()
        // TODO Must keep reference to mouse down canvas x and last mouse move canvas x. May conflict with mouse move logic and require additional resolution.
        // this.updateSelectionView({
        //   corner1: mouseDownProperties.coords,
        //   corner2: coords
        // })
        this.autoscrollCanvas()
      })
    },
    clearAutoscroll () {
      this.autoscrollSpeed = 0
      if (this.autoscrollTimeout) {
        clearTimeout(this.autoscrollTimeout)
      }
      this.autoscrollTimeout = 0
    }
  }
}

export default mixin
